module.exports = __webpack_public_path__ + "static/media/Aztec Warrior.11a38302.jpg";